/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSendSafelyRecipientInfoRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {GetSendSafelyRecipientInfoResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const getSendSafelyRecipientInfo = (request: GetSendSafelyRecipientInfoRequest, options?: CashRequestOptions) => post<GetSendSafelyRecipientInfoRequest, GetSendSafelyRecipientInfoResponse>("/2.0/cash/get-send-safely-recipient-info", request, {...options, rejectOnError: true })